function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar",
  transform: "translate(-308.631 -308.624)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_443",
  "data-name": "Path 443",
  d: "M331.778,310.992h-3.42v-1.579a.789.789,0,1,0-1.578,0v1.579h-4.735v-1.579a.789.789,0,1,0-1.578,0v1.579h-4.734v-1.579a.789.789,0,1,0-1.578,0v1.579h-3.419a2.1,2.1,0,0,0-2.1,2.1v18.675a2.1,2.1,0,0,0,2.1,2.1h21.043a2.1,2.1,0,0,0,2.1-2.1V313.1A2.1,2.1,0,0,0,331.778,310.992Zm.526,20.779a.526.526,0,0,1-.526.526H310.735a.526.526,0,0,1-.526-.526V313.1a.526.526,0,0,1,.526-.526h3.419v1.579a.789.789,0,0,0,1.578,0V312.57h4.734v1.579a.789.789,0,0,0,1.578,0V312.57h4.735v1.579a.789.789,0,0,0,1.578,0V312.57h3.42a.526.526,0,0,1,.526.526Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_31",
  "data-name": "Rectangle 31",
  width: 3.156,
  height: 2.367,
  transform: "translate(314.155 318.094)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_32",
  "data-name": "Rectangle 32",
  width: 3.156,
  height: 2.367,
  transform: "translate(314.155 322.039)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_33",
  "data-name": "Rectangle 33",
  width: 3.156,
  height: 2.367,
  transform: "translate(314.155 325.985)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_34",
  "data-name": "Rectangle 34",
  width: 3.156,
  height: 2.367,
  transform: "translate(319.678 325.985)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_35",
  "data-name": "Rectangle 35",
  width: 3.156,
  height: 2.367,
  transform: "translate(319.678 322.039)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_36",
  "data-name": "Rectangle 36",
  width: 3.156,
  height: 2.367,
  transform: "translate(319.678 318.094)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_37",
  "data-name": "Rectangle 37",
  width: 3.157,
  height: 2.367,
  transform: "translate(325.202 325.985)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_38",
  "data-name": "Rectangle 38",
  width: 3.157,
  height: 2.367,
  transform: "translate(325.202 322.039)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_39",
  "data-name": "Rectangle 39",
  width: 3.157,
  height: 2.367,
  transform: "translate(325.202 318.094)"
}));

var SvgKalenteriIcon = function SvgKalenteriIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.251,
    height: 25.252,
    viewBox: "0 0 25.251 25.252",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKalenteriIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kalenteri-icon.bddddfca.svg";
export { ForwardRef as ReactComponent };